module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.0bbfc705.woff";